/** Sunucu görsel proxy'sinde boyut seçimi (V5-09). */
import { recordSwallowed } from './swallowed.ts';

export type ProxyImageSize = 'w185' | 'w342' | 'w500' | 'w780' | 'original';

/**
 * `/api/metadata/image` URL'sinin `size` parametresini değiştirir.
 *
 * Yalnız kendi proxy'mizde çalışır; yerel thumbnail veya harici URL'ler
 * olduğu gibi kalır. Böylece kartlarda 40 px'lik kapak için 500 px indirmek
 * gibi gereksiz trafik oluşmaz.
 */
export function resizeProxyImage(
  url: string | null | undefined,
  size: ProxyImageSize,
): string | null {
  if (url === null || url === undefined || url === '') return null;
  let parsed: URL;
  try {
    parsed = new URL(url, 'http://pbfork.local');
  } catch (error) {
    recordSwallowed('imageSize', error);
    return url;
  }
  if (parsed.pathname !== '/api/metadata/image') return url;
  /*
   * Tizen 2.3 / Chromium 34 `URL.searchParams` desteklemez. Eski TV'de
   * `searchParams` undefined olduğunda ana sayfa kitaplık kartları çöküyordu;
   * sorgu dizesini elle yeniden kur.
   */
  const params = parsed.searchParams;
  const prefix = /^https?:\/\//i.test(url) ? parsed.origin : '';
  if (params === undefined || typeof params.set !== 'function') {
    const query = parsed.search.replace(/^\?/, '');
    const parts = query.split('&').filter((part) => part.length > 0 && !part.startsWith('size='));
    parts.push(`size=${encodeURIComponent(size)}`);
    return `${prefix}${parsed.pathname}?${parts.join('&')}`;
  }
  params.set('size', size);
  return `${prefix}${parsed.pathname}?${params.toString()}`;
}

function isProxyImage(url: string): boolean {
  try {
    return new URL(url, 'http://pbfork.local').pathname === '/api/metadata/image';
  } catch (error) {
    recordSwallowed('imageSize', error);
    return false;
  }
}

/** Proxy URL'si için 1x/2x kaynak kümesi; yerel görselde `undefined`. */
export function proxyImageSrcSet(
  url: string | null | undefined,
  base: ProxyImageSize,
  high: ProxyImageSize,
): string | undefined {
  if (url === null || url === undefined || !isProxyImage(url)) return undefined;
  const first = resizeProxyImage(url, base);
  const second = resizeProxyImage(url, high);
  if (first === null || second === null) return undefined;
  return `${first} 1x, ${second} 2x`;
}
